import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Picture} from "@pg-design/picture-module";
import {navigationHeight} from "@pg-rp/navigation";

import {HOMEPAGE_HEADER_RENDER_VARIANT_ID} from "../../app/render_variants/render_variant_ids";
import {selectRenderVariant} from "../../app/render_variants/render_variants_slice";
import {IRPStore} from "../../app/rp_reducer";
import {useBoundingClientRect} from "../../hooks/use_bounding_client_rect";
import {HomepageHeaderContent} from "./HomepageHeaderContent";
import {HomepageSearch} from "./HomepageSearch";

const headerImages = [
    {
        mobile: require("../images/header_1_mobile.jpg"),
        desktopSmall: require("../images/header_1_desktop_small.jpg"),
        desktopBig: require("../images/header_1_desktop_big.jpg")
    },
    {
        mobile: require("../images/header_2_mobile.jpg"),
        desktopSmall: require("../images/header_2_desktop_small.jpg"),
        desktopBig: require("../images/header_2_desktop_big.jpg")
    },
    {
        mobile: require("../images/header_3_mobile.jpg"),
        desktopSmall: require("../images/header_3_desktop_small.jpg"),
        desktopBig: require("../images/header_3_desktop_big.jpg")
    }
] as const;

export const HomepageHeader = () => {
    const headerVariant = useSelector((state: IRPStore) => selectRenderVariant(state, HOMEPAGE_HEADER_RENDER_VARIANT_ID));
    const headerImage = headerImages[headerVariant] ?? headerImages[0];
    const {boundingClientRect: headerBoundingClientRect, elementRef: headerElementRef} = useBoundingClientRect<HTMLDivElement>();

    const blendHeight = `${(headerBoundingClientRect?.height || 0) + navigationHeight}px`;
    const blendTopPosition = headerBoundingClientRect ? `${Math.max(Math.floor(headerBoundingClientRect.height - navigationHeight), 0)}px` : "0px";

    return (
        <section className={homepageHeader}>
            <div className={homepageHeaderFrame} ref={headerElementRef}>
                <div className={homepageHeaderImageClip}>
                    <Picture
                        sources={[
                            {minWidthPX: 0, src: headerImage.mobile, height: 836, width: 720},
                            {minWidthPX: 600, src: headerImage.desktopSmall, height: 1080, width: 2256},
                            {minWidthPX: 1366, src: headerImage.desktopBig, height: 1080, width: 3024}
                        ]}
                        alt="header"
                        className={headerImageCss}
                        fit="center center"
                        fetchPriority="high"
                    />
                </div>

                <div className={homepageHeaderContentPositioner}>
                    <div className={homepageHeaderContentGroup}>
                        <HomepageHeaderContent />
                        <HomepageSearch
                            containerHeight={blendHeight}
                            blendTopPosition={blendTopPosition}
                            layoutVariant="hero"
                            submitMode="manual"
                            mobileSelectionMode="selectAndClose"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export const homepageHeader = css({
    display: "flex",
    justifyContent: "center",
    width: "100%",
    px: 0,

    sm: {
        px: 3,
        pt: 2
    },

    lg: {
        px: 4
    }
});

export const homepageHeaderFrame = css({
    position: "relative",
    width: "100%",
    maxWidth: "1280px",
    height: "420px",
    overflow: "visible",

    sm: {
        height: "360px"
    },

    md: {
        height: "540px"
    },

    lg: {
        maxWidth: "var(--grid-lg-widthPx)",
        height: "540px"
    },

    xl: {
        height: "540px"
    }
});

export const homepageHeaderImageClip = css({
    position: "absolute",
    inset: 0,
    overflow: "hidden",

    sm: {
        borderRadius: 2
    }
});

export const homepageHeaderContentPositioner = css({
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    alignItems: "stretch",
    justifyContent: "center",
    boxSizing: "border-box",
    width: "100%",
    px: 2,
    pt: 3,
    pb: 3,
    zIndex: 10,

    md: {
        alignItems: "center",
        px: 4,
        pt: 0,
        pb: 0
    }
});

export const homepageHeaderContentGroup = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    height: "100%",
    gap: 0,

    md: {
        justifyContent: "center",
        height: "auto",
        gap: "6.4rem"
    }
});

export const headerImageCss = css({
    width: "100%",
    height: "100%",

    "& img": {
        width: "100%",
        height: "100%",
        maxWidth: "none",
        objectFit: "cover"
    }
});
import {useSelector} from "react-redux";
import {css} from "@panda/css";

import {Picture} from "@pg-design/picture-module";
import {navigationHeight} from "@pg-rp/navigation";

import {HOMEPAGE_HEADER_RENDER_VARIANT_ID} from "../../app/render_variants/render_variant_ids";
import {selectRenderVariant} from "../../app/render_variants/render_variants_slice";
import {IRPStore} from "../../app/rp_reducer";
import {useBoundingClientRect} from "../../hooks/use_bounding_client_rect";
import {HomepageHeaderContent} from "./HomepageHeaderContent";
import {HomepageSearch} from "./HomepageSearch";

const headerImages = [
    {
        mobile: require("../images/header_1_mobile.jpg"),
        desktopSmall: require("../images/header_1_desktop_small.jpg"),
        desktopBig: require("../images/header_1_desktop_big.jpg")
    },
    {
        mobile: require("../images/header_2_mobile.jpg"),
        desktopSmall: require("../images/header_2_desktop_small.jpg"),
        desktopBig: require("../images/header_2_desktop_big.jpg")
    },
    {
        mobile: require("../images/header_3_mobile.jpg"),
        desktopSmall: require("../images/header_3_desktop_small.jpg"),
        desktopBig: require("../images/header_3_desktop_big.jpg")
    }
] as const;

export const HomepageHeader = () => {
    const headerVariant = useSelector((state: IRPStore) => selectRenderVariant(state, HOMEPAGE_HEADER_RENDER_VARIANT_ID));
    const headerImage = headerImages[headerVariant] ?? headerImages[0];
    const {boundingClientRect: headerBoundingClientRect, elementRef: headerElementRef} = useBoundingClientRect<HTMLDivElement>();

    const blendHeight = `${(headerBoundingClientRect?.height || 0) + navigationHeight}px`;
    const blendTopPosition = headerBoundingClientRect ? `${Math.max(Math.floor(headerBoundingClientRect.height - navigationHeight), 0)}px` : "0px";

    return (
        <section className={homepageHeader}>
            <div className={homepageHeaderFrame} ref={headerElementRef}>
                <div className={homepageHeaderImageClip}>
                    <Picture
                        sources={[
                            {minWidthPX: 0, src: headerImage.mobile, height: 836, width: 720},
                            {minWidthPX: 600, src: headerImage.desktopSmall, height: 1080, width: 2256},
                            {minWidthPX: 1366, src: headerImage.desktopBig, height: 1080, width: 3024}
                        ]}
                        alt="header"
                        className={headerImageCss}
                        fit="center center"
                        fetchPriority="high"
                    />
                </div>

                <div className={homepageHeaderContentPositioner}>
                    <div className={homepageHeaderContentGroup}>
                        <HomepageHeaderContent />
                        <HomepageSearch
                            containerHeight={blendHeight}
                            blendTopPosition={blendTopPosition}
                            layoutVariant="hero"
                            submitMode="manual"
                            mobileSelectionMode="selectAndClose"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export const homepageHeader = css({
    display: "flex",
    justifyContent: "center",
    width: "100%",
    px: 0,

    sm: {
        px: 3,
        pt: 2
    },

    lg: {
        px: 4
    }
});

export const homepageHeaderFrame = css({
    position: "relative",
    width: "100%",
    maxWidth: "1280px",
    height: "420px",
    overflow: "visible",

    sm: {
        height: "360px"
    },

    md: {
        height: "540px"
    },

    lg: {
        maxWidth: "var(--grid-lg-widthPx)",
        height: "540px"
    },

    xl: {
        height: "540px"
    }
});

export const homepageHeaderImageClip = css({
    position: "absolute",
    inset: 0,
    overflow: "hidden",

    sm: {
        borderRadius: 2
    }
});

export const homepageHeaderContentPositioner = css({
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    alignItems: "stretch",
    justifyContent: "center",
    boxSizing: "border-box",
    width: "100%",
    px: 2,
    pt: 3,
    pb: 3,
    zIndex: 10,

    md: {
        alignItems: "center",
        px: 4,
        pt: 0,
        pb: 0
    }
});

export const homepageHeaderContentGroup = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    height: "100%",
    gap: 0,

    md: {
        justifyContent: "center",
        height: "auto",
        gap: "6.4rem"
    }
});

export const headerImageCss = css({
    width: "100%",
    height: "100%",

    "& img": {
        width: "100%",
        height: "100%",
        maxWidth: "none",
        objectFit: "cover"
    }
});
